module.exports = __webpack_public_path__ + "static/media/logo.e4e61684.png";